const formatDate = date => date.toLocaleDateString('en-GB');

export default formatDate;
